<template>
  <b-modal
    v-model="open"
    hide-footer
    modal-class="slide-in-modal"
    hide-header-close
    @close="onClose"
  >
    <p class="slide-in-modal__title">
      {{ $t('property.slide_in.title') }}
    </p>
    <div class="slide-in-modal__text">
      {{ $t('property.slide_in.text') }}
    </div>
    <b-button
      class="my-4 is--active"
      variant="primary"
      :href="contactUrl"
    >
      {{ $t('property.slide_in.button_text') }}
    </b-button>
    <b-button
      variant="link"
      class="slide-in-modal__close d-block"
      @click.prevent="onClose"
    >
      {{ $t('property.slide_in.close') }}
    </b-button>
    <a />
  </b-modal>
</template>
<script>
import Cookies from 'js-cookie'

const COOKIE_KEY = "cumLaude_propertyDetailSlideIn"
export default {
  props: {
    contactUrl: {
      type: String,
      required: true
    },
    delay: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    open: false
  }),
  computed: {
    delayInMilliseconds() {
      return this.delay * 60 * 1000
    }
  },
  mounted() {
    const _this = this
    const cookie = Cookies.get(COOKIE_KEY)
    if (!cookie) {
      setTimeout(() => {
        _this.open = true
      }, this.delayInMilliseconds)
    }
  },
  methods: {
    onClose() {
      this.open = false;
      Cookies.set(COOKIE_KEY, 1, {
        expires: 3
      })
    }
  }
}
</script>
<style lang="scss">
@import "../../scss/common/mixins";
@import "../../scss/common/variables";
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins/breakpoints";

.slide-in-modal {
  .modal-dialog {
    margin: 0 0 0 auto;
    top: 50%;

    @include media-breakpoint-down(sm) {
      max-width: 98%;
    }

    .modal-content {
      border: none;
      border-radius: 0;
      @include noisyBackground();
    }

    .modal-title {
      height: 1px;
      background: $dark-grey;
      opacity: 0.25;
      width: calc(100% - 60px);
      margin-left: auto;
      position: relative;

      &:before {
        content: '\E92F';
        font-family: $icons-font-family;
        position: absolute;
        left: -50px;
        top: 50%;
        transform: translateY(-50%) rotate(90deg);
        font-size: 38px;
      }
    }

    .modal-body {
      border: none;
      border-radius: 0;
      padding: 52px 82px;

      @include media-breakpoint-down(sm) {
        padding: 40px 62px;
      }
    }

    .modal-header {
      border: none;
      border-radius: 0;
      padding: 55px 33px 0;
    }

    .slide-in-modal__title {
      font-family: $headings-font-family;
      font-weight: 500;
      color: $dark-grey;
      letter-spacing: 3px;
      font-size: 34px;
      text-transform: uppercase;
      line-height: 1.2;

      @include media-breakpoint-down(sm) {
        font-size: 28px;
      }

      &:after {
        content: '';
        display: block;
        margin: 12px 0;
        height: 0.75px;
        background: $dark-grey;
        width: 240px;
        opacity: 0.5;
        position: relative;
      }
    }

    .slide-in-modal__close {
      color: $gray-600;
      padding: 0;
    }
  }

  &.fade {
    .modal-dialog {
      transform: translate(100%, -50%) !important;
    }

    transition: all 400ms ease-in-out;
  }

  &.show {
    .modal-dialog {
      transform: translate(0, -50%) !important;
    }
  }
}
</style>